export const parseValidDateString = (date) => {
  return date.split('-').map((part) => part.padStart(2, '0')).join('-')
}
